import { supabase } from './supabase';
import type { SiteStatus } from './siteStatus';

/**
 * Service du statut de site (super admin) — écriture Supabase via RPC sécurisée
 * `set_tenant_site_status` (SECURITY DEFINER, réservée au super_admin),
 * cf. sql/31_site_status.sql. Logique pure dans siteStatus.ts (testée à part).
 */

export interface SetSiteStatusResult {
  ok: boolean;
  error?: string;
}

/** Change le statut du site d'un resto (active / suspended / disabled). */
export async function setSiteStatus(tenantId: string, status: SiteStatus): Promise<SetSiteStatusResult> {
  const { error } = await supabase.rpc('set_tenant_site_status', {
    p_tenant_id: tenantId,
    p_status: status,
  });
  if (error) return { ok: false, error: `Changement de statut impossible : ${error.message}` };
  return { ok: true };
}
